import { useQuery } from '@hooks/reactQuery';

import { map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getRentedAssetIdsByType } from '@api/assetsRent';

import { IId } from '@interfaces/common/common';

import { ACQUIRED_ASSETS_FILTER } from '@constants/queryKeys';

export const useQueryAcquiredAssetIdsByType = () => {
	const {
		isAcquiredAssetsShownApplied,
		appliedAcquiredAssetsTypeFilter,
	} = useAppSelector(map);

	const { data, isInitialLoading } = useQuery({
		queryKey: [ACQUIRED_ASSETS_FILTER, appliedAcquiredAssetsTypeFilter, isAcquiredAssetsShownApplied],
		queryFn: () => getRentedAssetIdsByType(appliedAcquiredAssetsTypeFilter),
		select: (data) => data?.map((item: IId) => item?.id),
		enabled: [isAcquiredAssetsShownApplied],
	});

	return {
		acquiredAssetIds: data || [],
		isLoadingAcquiredAssetIds: isInitialLoading,
	};
};
